import type { ComponentProps } from 'react'
import type { SchemaOf } from 'yup'
import { object, string } from 'yup'

import type { Tag } from '@fourthwall/components'

import type { ConfigureValues, MetaConfiguration } from './AppsMeta.types'

export const metaConfigurationStatusTagMap: Record<
  MetaConfiguration['type'],
  ComponentProps<typeof Tag>
> = {
  NOT_CONNECTED: {
    label: 'Not connected',
    appearance: 'alert',
  },
  CONFIGURED: {
    label: 'Configured',
    appearance: 'success',
  },
  NOT_CONFIGURED: {
    label: 'Requires setup',
    appearance: 'alert',
  },
}

export const ConfigureSchema: SchemaOf<ConfigureValues> = object({
  metaCatalogId: string().required(),
})
